import { NgModule } from "@angular/core";
import { EntryDepositSelectDepositButtonComponent } from "@modules/+new/payments/features/entry-deposit/features/entry-deposit-select-deposit-type/components/entry-deposit-select-deposit-button/entry-deposit-select-deposit-button.component";
import { EntryDepositSelectDepositTypeComponent } from "@modules/+new/payments/features/entry-deposit/features/entry-deposit-select-deposit-type/entry-deposit-select-deposit-type.component";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	imports: [TranslationPipeModule, UniversalModalModule, CommonModule, CoreModule],
	exports: [EntryDepositSelectDepositTypeComponent],
	declarations: [EntryDepositSelectDepositTypeComponent, EntryDepositSelectDepositButtonComponent]
})
export class EntryDepositModule {}
